import { ClosePickerUnderlay } from '@davidlloydleisure/common-js-frontend';
import classNames from 'classnames';
import React from 'react';

import { SiteContext } from 'src/context/site-context';
import { getAllLanguagesForBuildType } from 'src/enums/build/build-type';

import * as styles from './index.module.scss';
import LanguageItem from './language-item';
import LanguagePickerPopup from './language-picker-popup';

const LanguagePicker: React.FC = () => {
  const [pickerOpen, setPickerOpen] = React.useState(false);
  const { language: currentLanguage, pageLanguages, buildType } = React.use(SiteContext);
  const allLanguagesForBuildType = getAllLanguagesForBuildType(buildType);
  const orderedLanguages = allLanguagesForBuildType
    .map((l) => pageLanguages?.find((p) => p.language === l))
    .filter((p) => !!p);

  if (orderedLanguages.length < 2) {
    return null;
  }

  return (
    <div className={styles.wrapper}>
      {pickerOpen && <ClosePickerUnderlay closePicker={() => setPickerOpen(false)} />}
      <div
        className={classNames('language-toggle', styles.toggle)}
        onClick={() => setPickerOpen(!pickerOpen)}
      >
        <LanguageItem language={currentLanguage} withChevron isChevronExpanded={pickerOpen} />
        {pickerOpen && (
          <LanguagePickerPopup currentLanguage={currentLanguage} pageLanguages={orderedLanguages} />
        )}
      </div>
    </div>
  );
};

export default LanguagePicker;
